import { useContext } from 'react';
import { SnackbarContext } from './snackbarProvider';

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
